import './FacetsContent.scss';
import React from 'react';
import {FacetGroup} from './FacetGroup/FacetGroup';
import {useFacets} from '../duck/filter.hooks';
import {HibuFacetGroup} from '../facet.types';
import {ListGroup} from 'react-bootstrap';
import {facetUtils} from '../facet.utils';

export const FacetsContent = React.memo(() => {
    const facets: HibuFacetGroup[] = useFacets();

    return (
        <div id="facets-list">
            <ListGroup>
                {facets.map(((group: HibuFacetGroup) =>
                        facetUtils.shouldDisplayFacetGroup(group) &&
                        <FacetGroup group={group} key={group.fieldName}></FacetGroup>
                ))}
            </ListGroup>
        </div>
    );
});
